<template>
  <div>
    <wc-data-box
      :title='subd.title'
      :titleIcon='subd.icon'
      :titleIconColor='subd.color'
      :showEdit='!project.archived'
      @edit='edit'
    >
      <wc-two-column-table :items='items'></wc-two-column-table>
      <v-card-text class='mt-n4 grey--text text--darken-4'>{{ project.project_detail.customer_tier_explanation }}</v-card-text>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      :title='subd.title'
      :icon='subd.icon'
      :iconColor='subd.color'
      :disableButtons='!isFormValid'
      :loadingButtons='isLoading'
      @cancel='showDialog = false'
      @save='save'
      width='400'
    >
      <v-form v-model='isFormValid'>
        <v-autocomplete
          :items='SUBDTiers'
          return-object
          :item-text='getText'
          v-model='tierCopy'
          label='Choose a tier'
          :loading='isLoading' 
          :rules='[rules.required]'         
        ></v-autocomplete>
          <span v-if='projectCopy.project_detail.subd_tier' class='mt-2 caption grey--text'>
            {{ tierCopy.is_custom ? "Set custom prices & times for this project below" : "Prices/times of standard tiers cannot be edited here"}}
          </span>
          <span v-else class='mt-2 caption error--text'>
            Please choose a tier
          </span>
          <v-row> 
            <v-col cols='12' sm='6'>
              <v-text-field
                prepend-inner-icon='mdi-currency-usd'
                label='SU Price'
                :rules='[rules.decimal]'
                v-model='tierCopy.su_price'
                :disabled='!tierCopy.is_custom || !projectCopy.project_detail.subd_tier'
              ></v-text-field>
            </v-col>
            <v-col cols='12' sm='6'>
              <v-text-field
                prepend-inner-icon='mdi-alarm'
                label='SU TOS (mins)'
                :rules='[rules.int]'
                v-model='tierCopy.su_time'
                :disabled='!tierCopy.is_custom || !projectCopy.project_detail.subd_tier'
              ></v-text-field>
            </v-col>
            <v-col cols='12' sm='6'>
              <v-text-field
                prepend-inner-icon='mdi-currency-usd'
                label='BD Price'
                :rules='[rules.decimal]'
                v-model='tierCopy.bd_price'
                :disabled='!tierCopy.is_custom || !projectCopy.project_detail.subd_tier'
              ></v-text-field>
            </v-col>
            <v-col cols='12' sm='6'>
              <v-text-field
                prepend-inner-icon='mdi-alarm'
                label='BD TOS (mins)'
                :rules='[rules.int]'
                v-model='tierCopy.bd_time'
                :disabled='!tierCopy.is_custom || !projectCopy.project_detail.subd_tier'
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols='12'>
              <v-textarea
                outlined
                label='Tier Reason'
                v-model='projectCopy.project_detail.customer_tier_explanation'
                :disabled='!projectCopy.project_detail.subd_tier'
                hint='(optional)'
              ></v-textarea>
            </v-col>
          </v-row>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import irrigationsAPI from '@/modules/irrigation/api/irrigations'
import formRules from '@/mixins/formRules'

export default {
  name: 'irrigation-subd-tier',
  mixins: [formRules],
  props: {
    project: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    isFormValid: false,
    showDialog: false,
    SUBDTiers: [],
    tierCopy: {},
    projectCopy: { project_detail: { subd_tier_obj: {} } },
    newCustomTier: {
      tier_number: '',
      description: 'Custom',
      su_price: 0.0,
      bd_price: 0.0,
      su_time: 0,
      bd_time: 0,
      is_custom: true
    }
  }),
  computed: {
    ...mapState({
      subd: state => state.icons.dataBox.subdTier
    }),
    tier () {
      return this.project.project_detail.subd_tier
    },
    tier_obj () {
      return this.project.project_detail.subd_tier_obj
    },
    items () {
      return [
        { text: 'System tier', value: this.tier ? (this.tier_obj.tier_number + ' - ' + this.tier_obj.description) : '(not set)' },
        { text: 'Startup Price', value: this.tier ? this.$options.filters.decMoney(this.tier_obj.su_price) : '' },
        { text: 'SU Time on Site', value: this.tier ? (this.tier_obj.su_time + ' mins') : '' },
        { text: 'Blowdown Price', value: this.tier ? this.$options.filters.decMoney(this.tier_obj.bd_price) : '' },
        { text: 'BD Time on Site', value: this.tier ? (this.tier_obj.bd_time + ' mins') : '' },
        { text: 'Tier Reason:', value: '' }
      ]
    },
  },
  methods: {
    edit () {
      this.showDialog = true
      if (this.SUBDTiers.length == 0) { this.setupData() }
        console.log('edit')
      this.projectCopy = _.cloneDeep(this.project)
      if (this.project.project_detail.subd_tier) {
        this.tierCopy = _.cloneDeep(this.project.project_detail.subd_tier_obj)
      } else {
        this.tierCopy = {}
      }
    },
    async setupData () {
      this.isLoading = true
      let tmp = await irrigationsAPI.getSubdTiers()
      this.SUBDTiers = _.orderBy(_.filter(tmp, t => t.tier_number !== 'Custom'), 'tier_number')
      // presenting Custom at the bottom of the list.
      this.SUBDTiers.push(this.newCustomTier)
      this.newCustomTier.description = 'Custom: ' + this.project.name;
      this.newCustomTier.tier_number = 'Custom: ' + this.project.name;
      this.isLoading = false
    },
    getText (item) {
      return item.tier_number + " - " + item.description
    },
    async save () {
      this.isLoading = true
      if (this.tierCopy.is_custom) {
        if (this.tierCopy.id) {
          this.tierCopy = await irrigationsAPI.updateSubdTier(this.tierCopy)
        } else {
          this.tierCopy = await irrigationsAPI.newSubdTier(this.tierCopy)
        }
      }
      // if was a custom tier, and has been changed to a listed tier - go and delete the old custom tier
      if (this.project.project_detail.subd_tier && this.project.project_detail.subd_tier_obj.is_custom && !this.tierCopy.is_custom) {
        await irrigationsAPI.deleteSubdTier(this.project.project_detail.subd_tier_obj)
      }
      this.projectCopy.project_detail.subd_tier = this.tierCopy.id
      this.$emit('update', this.projectCopy)
      this.showDialog = false
      this.isLoading = false
    }
  }
}
</script>
